import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/shoppingflow/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import AllProducts from './pages/shoppingflow/Products';
import DetailPage from './pages/shoppingflow/DetailPage';

import './App.css';

import './firebase';
import Cart from './pages/shoppingflow/Cart';
import AboutUs from './pages/basic/AboutUs';
import FAQ from './pages/basic/FAQ';
import MyAccount from './pages/shoppingflow/MyAccount';
import TermsAndConditions from './pages/basic/TermsAndConditions';
import SearchResultsPage from './components/SearchResultsPage';
import OrderConfirmationPage from './pages/shoppingflow/OrderConfirmationPage';
import OrderTracking from './pages/shoppingflow/OrderTracking';
import TopSelling from './pages/shoppingflow/TopSelling';

import PrivacyPolicy from './pages/basic/PrivacyPolicy';
import RefundPolicy from './pages/basic/RefundPolicy';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/all-products" element={<AllProducts />} />
        <Route path="/detail/:id" element={<DetailPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/account" element={<MyAccount />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
        <Route path="/order-tracking" element={<OrderTracking />} />
        <Route path="/top-selling" element={<TopSelling />} />

        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
